import { useEffect } from 'react';
import type { LngTerminals } from 'src/apis/lng-marketing/types';
import type { LngMarketingRootRequest } from 'src/apis/lng-marketing/use-lng-marketing-root';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  lngMarketingRoot: LngMarketingRootRequest;
};

type ExecuteOptions = {
  url: string;
};

export function useTerminals({ lngMarketingRoot }: HookOptions) {
  const terminals = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) =>
      axios.request<LngTerminals>({
        ...baseConfig,
        url,
        // As for now, we always want to include inactive LSOs.
        params: { includeInactiveLsos: true },
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!lngMarketingRoot.response) return;

    terminals.execute({
      url: lngMarketingRoot.response.data._links.getTerminals.href,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [lngMarketingRoot.response]);

  return terminals;
}

export type TerminalsRequest = ReturnType<typeof useTerminals>;
